export const ACCEPT_PAYMENT_PLAN = 'Accept Payment Plan';
export const ADYEN_PAYMENT_RESULT = 'Adyen payment result';
export const BLOG_ADVERTISER = 'Blog advertiser';
export const BLOG_TENANT = 'Blog tenant';
export const BLOG_COUNTRY = 'Blog country';
export const BLOG_CITY = 'Blog city';
export const APOLLO_CITY = 'City';
export const APOLLO_COUNTRY = 'CountryGuide';
export const APOLLO_GUIDE = 'Guide';
export const APOLLO_UNIVERSITY = 'UniLanding';
export const APOLLO_UNIVERSITY_SIGN_UP = 'UniSignup';
export const APOLLO_COMMUNITY = 'Community';
export const APOLLO_SUPPLY_LANDING = 'Supply landing';
export const BOOKING = 'Booking';
export const CITY = 'City';
export const COUNTRY = 'Country';
export const CONTACT = 'Contact';
export const CONTACT_ADVERTISER = 'Contact advertiser';
export const COOKIES_POLICY = 'Cookies policy';
export const DATA_SECURITY = 'Data security';
export const EAIE = 'EAIE';
export const EDIT_LISTING = 'Edit listing';
export const LISTING_CREATION_FLOW = 'LCF';
export const EDIT_PROFILE = 'Edit profile';
export const FAQ = 'FAQ';
export const FAVORITE_LISTINGS = 'Favorite listings';
export const SEARCH_ALERT_LISTINGS = 'Search alert listings';
export const FEATURE = 'Feature';
export const HELP_CENTER = 'Help Center';
export const HOME = 'Home';
export const HOW_IT_WORKS = 'How it works';
export const HOW_IT_WORKS_NEXT = 'How it works next';
export const INBOX = 'Inbox';
export const LEGAL = 'Legal';
export const LIST_YOUR_PLACE = 'List your place';
export const LISTINGS = 'Listings';
export const LISTING_CALENDAR = 'Listing calendar';
export const LISTING_DETAIL_PAGE = 'LDP';
export const LOGIN = 'Login';
export const NOT_FOUND = 'Not found';
export const OTHER = 'Other';
export const PARTNER_REDIRECT = 'Partner redirect';
export const PAYMENTS = 'Payments';
export const PAYMENT_METHODS = 'Payment methods';
export const PAYMENT_PLAN = 'Payment plan';
export const PAYMENTS_PAYMENT_REQUESTS = 'Payments Payment requests';
export const PILLAR = 'Pillar';
export const PRICING = 'Pricing';
export const PRESS_RELEASES = 'Press releases';
export const RECOVER_ACCOUNT = 'Recover account';
export const REGISTER = 'Register';
export const REGISTER_PARTNER = 'Register Partner';
export const RESERVATIONS = 'Reservations';
export const RESET_PASSWORD = 'Reset password';
export const SAFE_PAYMENT_SERVICE = 'Safe payment service';
export const SEARCH = 'Search';
export const SHARE_ROOM = 'Share room';
export const LISTING_SUCCESS = 'Listing success';
export const SUBSCRIPTIONS = 'Subscriptions';
export const SEARCH_ALERTS_UNSUBSCRIBE = 'SearchAlertsUnsubscribe';
export const SITEMAP = 'Sitemap';
export const SOMETHING_WENT_WRONG = 'Error';
export const TALK = 'TALK';
export const TERMS = 'Terms';
export const UNDER_REVIEW = 'Under review';
export const UNIVERSITIES = 'Universities';
export const USER = 'UserPage';
export const USER_DASHBOARD = 'User dashboard';
export const VERIFICATION = 'Verification';
export const PAYMENT_REQUESTS = 'Payment requests';
export const PAY_PAYMENT_REQUESTS = 'External Payment';
export const VERIFY_PHONE_NUMBER = 'Verify phone number';
// --- /my/payouts ---
export const BILLING = 'Billing';
export const TRANSACTION_HISTORY = 'Transaction history';
export const INVOICES = 'Invoices';
export const COMMISSION_PLAN = 'Commission Plan';
export const PAYOUT_METHODS = 'Payout methods';
export const PAYOUT_ROUTING = 'Payout routing';
export const PAYOUTS_PAYMENT_REQUESTS = 'Payouts payment requests';
export const VERIFY_IDENTITY = 'Verify Identity';
